import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AlertService } from '../alert.service';
import { AccountStatsService } from '../account-stats.service';
import { AuthService } from '../auth.service';
import { setTimeout } from 'timers';

@Component({
  selector: 'app-mid-stage-account-ranks',
  templateUrl: './mid-stage-account-ranks.component.html',
  styleUrls: ['./mid-stage-account-ranks.component.scss']
})

export class MidStageAccountRanksComponent implements OnInit {

  public allRankings: Ranking[];

  public currentTime = new Date;
  public futureTime = new Date;

  public currentHour = this.currentTime.getHours();
  public delay = 0;
  
  constructor(
    private http: HttpClient,
    private alert: AlertService,
    public accountStats: AccountStatsService,
    public auth: AuthService,
    @Inject('BASE_URL') private baseUrl: string) {

    this.allRankings = [];

    this.loadMidstageAccounts();//load the midstage data 
  }

  //Method to reload the midstage page every hour
  ngOnInit(): void {
    window.localStorage.clear();
    this.futureTime.setTime(this.futureTime.getTime() + 3600000);
    this.futureTime.setMinutes(0);
    this.futureTime.setSeconds(0);

    this.delay = (this.futureTime.getTime() - this.currentTime.getTime());
    setTimeout(() => this.updatePage(), this.delay);
  }

  //Method to get the current record
  getupdatedAcountInfo(ranking: Ranking): Ranking {
    let updatedAccount = this.allRankings.find(x => x.accountNumber == ranking.accountNumber);
    return updatedAccount;
  }

  //Call for getting the midstage account data
  loadMidstageAccounts(): void {
    this.http.get<Ranking[]>(this.baseUrl + 'api/MidstageAccount/Get').subscribe(result => {
      this.allRankings = result;
        for (let i in this.allRankings) {
          this.allRankings[i].callAfter = Number(this.allRankings[i].timeToCall_EST.split(":")[0]);
          if (this.allRankings[i].timeZone == "EST") {
            this.allRankings[i].callBefore = 20; //set callBefore time to 8 P.M ET
          } else if (this.allRankings[i].timeZone == "CST") {
            this.allRankings[i].callBefore = 21; //set callBefore time to 9 P.M ET
          } else if (this.allRankings[i].timeZone == "MST") {
            this.allRankings[i].callBefore = 22; //set callBefore time to 10 P.M ET
          } else if (this.allRankings[i].timeZone == "PST") {
            this.allRankings[i].callBefore = 23; //set callBefore time to 11 P.M ET
          }
        }
      this.updateStats();
    }, error => {
      this.alert.error(`Error getting rankings`, false, 5);
      console.error(error)
      });
  }

  //To track the number of attempts the collector has made
  markAttempted(ranking: Ranking, index: number): void {
    let updatedAccount = this.getupdatedAcountInfo(ranking);
    updatedAccount.worked = true; //for stats
    if (updatedAccount.attempts) {
      updatedAccount.attempts = updatedAccount.attempts + 1;
    }
    else {
      updatedAccount.attempts = 1;
    }

    if (updatedAccount.attempts == 3) {
      this.markDone(ranking, index);
    }
     
    this.http.post(this.baseUrl + 'api/MidstageAccounts/Attempts', updatedAccount).subscribe(() => {
      this.loadMidstageAccounts();
    }, error => {
      this.alert.error("Error while updating the attempt in this record", false, 3);
      console.error(error);
      });

    this.updateStats();
  }

  //Updating the done data
  markDone(ranking: Ranking, index: number): void {
    let updatedAccount = this.getupdatedAcountInfo(ranking);
    updatedAccount.done = 1;
    updatedAccount.worked = true;
    this.updateStats();
    this.http.post(this.baseUrl + 'api/MidstageAccounts/Done', updatedAccount).subscribe(() => {
      this.loadMidstageAccounts();
    }, error => {
      this.alert.error("Error while updating the done for this record", false, 3);
      console.error(error);
    });
  }

  //Connecting to the flex website
  popScreen(ranking: Ranking, index: number): void {
    this.http.post<PopScreenResult>(this.baseUrl + 'api/FiservApi/PopScreen', ranking).subscribe(result => {
      if (result.HasErrors === true) {
        result.Errors.forEach(error => {
          var errorToShow: string;
          if (error.Description == 'User is not logged in or inactive') {
            errorToShow = 'Please login to Flex to continue';
          } else {
            errorToShow = error.Description;
          }
          this.alert.error(errorToShow, false, 5);
        });
      } else if (!result || result.HasErrors === null) {
        this.alert.error('Error communicating with fiserv.', false, 5);
      } else {
        this.markAttempted(ranking, index);
        this.alert.success('Successful!', false, 3);
      }
    }, error => {
      this.alert.error('Error communicating with the server.', false, 5);
      console.error(error);
    });
  }

  //updating the page every hour
  updatePage(): void {
    this.currentTime = new Date;
    this.currentHour = this.currentTime.getHours();
    this.loadMidstageAccounts();

    setTimeout(() => this.updatePage(), 3600000);
  }

  //Tracking the stats for deactivated numbers
  updateStats(): void {
    this.accountStats.midstageTotal = this.allRankings.length;
    this.accountStats.midstageWorked = this.allRankings.filter(x => x.worked).length;
    this.accountStats.midstageDone = this.allRankings.filter(x => x.done).length;
    this.accountStats.midstageTodo = this.accountStats.midstageTotal - this.accountStats.midstageDone - this.allRankings.filter(x => x.notes == "Do Not Call").length;
   }
  }

//Interface for the midstage data
class Ranking {
  asOfDate: Date;
  accountNumber: string;
  notes: string;
  dpd: number;
  futureDated: boolean;
  textEmailFlag: boolean;
  fiservUserId: string;
  loggedInUser: string;
  lastRPC: Date;
  timeToCall_EST: string;
  timeZone: string;
  worked: boolean;
  done: number;
  attempts: number;

  callAfter: number;
  callBefore: number;

  constructor() {
    this.worked = false;
    this.done = 0;
    this.attempts = 0;
    this.callAfter = 0;
    this.callBefore = 0;
  }
}

//Interface to connect to the fiserv API
interface PopScreenResult {
  Errors: PopScreenError[];
  HasErrors: boolean;
}

interface PopScreenError {
  Description: string;
  ErrorCode: string;
  IsBusinessError: boolean;
}



// WEBPACK FOOTER //
// ./src/app/mid-stage-account-ranks/mid-stage-account-ranks.component.ts